module.exports = __webpack_public_path__ + "static/img/tranthitinh.f8b4f34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tranthitinh.jpg
// module id = fDu+
// module chunks = 1